import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F6DA21B8-C4AD-48D1-9F97-9A59F721956B
 * name rocket-launch-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rocket-launch-outline.svg
 * tags
 * - Science 
 * - Transportation + Flying 
 */
export const RocketLaunchOutlineIcon = createSvgIcon(<><path d="M13.16 22.19L11.5 18.35C13.1 17.77 14.57 17 15.93 16.08L13.15 22.19M5.65 12.5L1.81 10.85L7.92 8.07C7 9.43 6.23 10.91 5.65 12.5M20 4C17.04 3.78 14.8 4.83 12.45 7.31C10.09 9.78 9.09 11.81 8.5 13.35L10.67 15.45C12.96 14.58 15 13.27 16.7 11.56C20 8.27 20.17 5.4 20 4M11 5.9C13.63 3.1 18 1.08 21.66 2.35C21.66 2.35 23.78 7.31 18.11 13C15.91 15.17 13.53 16.5 11.39 17.34C11.15 17.43 10.24 17.73 9.26 16.88L7.13 14.75C6.57 14.19 6.39 13.37 6.66 12.62C7.5 10.5 8.41 8.69 11 5.9M6.25 22H4.84L8.93 17.9C9.23 18.11 9.56 18.26 9.9 18.35L6.25 22M2 22V20.59L6.77 15.81L8.2 17.23L3.41 22H2M2 19.17V17.75L5.65 14.1C5.74 14.45 5.89 14.78 6.1 15.07L2 19.17M16 6C17.11 6 18 6.9 18 8C18 9.11 17.11 10 16 10C14.9 10 14 9.11 14 8C14 6.9 14.9 6 16 6Z" /></>, 'RocketLaunchOutlineIcon');
export default RocketLaunchOutlineIcon